import { LorebookVisibility } from "@next-platform/packages-ts-types";
import { z } from "zod";

import { FORM_FIELDS, MIN_PUBLIC_TAGS_COUNT } from "../constants";
import { ValidationSchemaT } from "../types";

export default function getLorebookRefineTags(t: ValidationSchemaT) {
  return (formValues: z.infer<z.ZodObject<Record<string, z.ZodTypeAny>>>, ctx: z.RefinementCtx) => {
    if (formValues[FORM_FIELDS.VISIBILITY] === LorebookVisibility.PUBLIC) {
      const tags = formValues[FORM_FIELDS.TAGS] as string[] | undefined;

      if (!tags || tags.length < MIN_PUBLIC_TAGS_COUNT) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: [FORM_FIELDS.TAGS],
          message: t("lorebook:validation.tags.requiredWhenPublic"),
        });
      }
    }
  };
}
